export default "__VITE_ASSET__BZhBR7NU__"